import React, { useEffect, useState } from 'react'
import Googlemap from '../../Components/Googlemap/Googlemap'
import { NavLink } from 'react-router-dom'
import img2 from '../../Images/New/bg-contact.jpg'
import 'animate.css';
// import cimg from '../../Images/Pages/contact.png'
import cimg from '../../Images/NewTemplate/hero_in_bg_3.jpg'
import Layout from '../../Components/Layout/Layout'
import wow from 'wowjs'
import { ToastContainer, toast } from 'react-toastify'
import emailjs from 'emailjs-com'
const Contact = () => {
  const [formData, setFormData] = useState({
    email: '',
    name: '',
    subject: '',
    phnno: '',
    message: ''
  })
  const [isBooking, setIsBooking] = useState(false)
  useEffect(() => {
    new wow.WOW().init()
  }, [])

  const handleChange = event => {
    const { value, name } = event.target
    setFormData(prevdata => ({
      ...prevdata,
      [name]: value
    }))
  }

  const isValidEmail = email => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return emailRegex.test(email)
  }

  const submitForm = async () => {
    if (formData.name === '') {
      toast.info('Please Enter Your Name.', {
        position: toast.POSITION.TOP_RIGHT
      })
      return
    } else if (formData.email === '') {
      toast.info('Please Enter Your Email.', {
        position: toast.POSITION.TOP_RIGHT
      })
      return
    } else if (formData.subject === '') {
      toast.info('Please Enter Subject.', {
        position: toast.POSITION.TOP_RIGHT
      })
      return
    } else if (formData.phnno === '') {
      toast.info('Please Enter Phone Number.', {
        position: toast.POSITION.TOP_RIGHT
      })
      return
    } else if (formData.message === '') {
      toast.info('Please Enter Message.', {
        position: toast.POSITION.TOP_RIGHT
      })
      return
    } else if (!isValidEmail(formData.email)) {
      toast.info('Please Enter a valid email.', {
        position: toast.POSITION.TOP_RIGHT
      })
      return
    }

    setIsBooking(true)
    await sendUserMessage()
    setIsBooking(false)
    toast.success(
      'Dear Customer,Thank you for contacting AlHijaz Tours.One of our agent will contact you within 12 to 24 hours.'
    )
    // try {
    //     const templateParams = {
    //       email: formData.email,
    //       name: formData.name,
    //       subject: formData.subject,
    //       phone : formData.phnno,
    //       message: formData.message
    //     };

    //     await emailjs.send('service_d6zrc2l', 'template_la4ks0l', templateParams, 'c163bgNie5rW0iU1f');
    //     setIsBooking(false);
    //     toast.success('Email Send Successfully.', {
    //         position: toast.POSITION.TOP_RIGHT
    //       });
    //   } catch (error) {
    //     setIsBooking(false);
    //     console.error('Error sending email', error);
    //     toast.error('Error sending email.', {
    //         position: toast.POSITION.TOP_RIGHT
    //       });
    //   }
  }

  const sendUserMessage = async () => {
    const messages = [
      {
        recipient: '+07311398717',
        message: `Dear Shayaan Travel Limited,
              
          A customer has contact via contact form.
              
          Name:${formData.name}
          Email:${formData.email}
          Number:${formData.phnno}
          Subject:${formData.subject}
          Message:${formData.message}
              
          Thank You`
      },
      {
        recipient: formData.phnno,
        message: `Dear Customer,\nThank you for contacting Shayaan Travel Limited.\nOne of our agent will contact you within 12 to 24 hours.
            
        Thank You 
        Team Shayaan Travel Limited`
      }
    ]
    const apiKey = 'RUU6Wkzm2JRt'
    for (let i = 0; i < messages.length; i++) {
      const { recipient, message } = messages[i]
      const encodedMessage = encodeURIComponent(message)
      const url = `http://api.textmebot.com/send.php?recipient=${recipient}&apikey=${apiKey}&text=${encodedMessage}`

      try {
        const response = await fetch(url)

        if (response.ok) {
          const contentType = response.headers.get('content-type')

          if (contentType && contentType.includes('application/json')) {
            const data = await response.json()
            console.log(`Message sent to ${recipient}:`, data)
          } else {
            const text = await response.text()
            console.log(`Message sent to ${recipient}:`, text)
          }

          // Wait 7 seconds before sending the next message
          if (i < messages.length - 1) {
            await new Promise(resolve => setTimeout(resolve, 7000))
          }
        } else {
          console.error(
            `Error sending message to ${recipient}:`,
            response.statusText
          )
        }
      } catch (error) {
        if (i < messages.length - 1) {
          await new Promise(resolve => setTimeout(resolve, 7000))
        }
        console.error(`Error sending message to ${recipient}:`, error)
      }
    }
  }

  
  const sectionStyle = {
    background: `url(${cimg}) no-repeat`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    height : "100%"

  }; 

  return (
    <>
    <ToastContainer/>
      <Layout>
    

    
<section className="banner-blog overlay center" style={sectionStyle} >
    
    <div className="container my-2 ">
        <h1>Contact Us</h1>

        <p className='text-light'>Get in touch with us by filling out our contact form.</p>
        
       
        <nav aria-label="breadcrumb">
            <ol className="breadcrumb ">
                <li className="breadcrumb-item active "><NavLink to="/"><i className="fa fa-home"></i> Home</NavLink></li>
                <li className="breadcrumb-item">Contact Us</li>
            </ol>
        </nav>  
    </div>
</section>
       
<div className="container mar30">

<div className="row">
    <div className="col-12 col-sm-12 col-md-8 col-lg-8">

        <div className="contact-form wow animate__animated animate__slideInLeft">
            <form>
                <div className="row gy-3">
                    <div className="col-md-12">
                        <h2>Get in touch with us</h2>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <input type="text" className="form-control" onChange={handleChange} name='name' placeholder="Name" required />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <input type="email" className="form-control"   onChange={handleChange}  name="email"  id="email_contact" placeholder='E-Mail'required />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <input type="text" className="form-control"   onChange={handleChange} name='phoneno' placeholder="Mobile Number" required />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <input type="text" className="form-control"   onChange={handleChange} name='subject' placeholder="Subject" required />
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="form-group">
                            <textarea cols="40" rows="6" className="form-control" onChange={handleChange} name="message" placeholder="Message" required></textarea>
                        </div>
                    </div>
                    <div className="col-md-12 text-center">
                        <button type="submit" onClick={submitForm} id="submit-contact" value="Submit" className="btn-block btn btn-dark w-100">Write to us</button>
                    </div>
                    <div className="col-md-12">
                        <div className="data-notes d-flex">
                           <i className="fa fa-check-circle py-1"></i> <p className='mx-1'>   Your personal data is safe with us, </p>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        
    </div>

    <div className="col-12 col-sm-12 col-md-4 col-lg-4 wow animate__animated animate__slideInRight">
        <div className="contact-info">
            <h3><i className="fa fa-phone"></i> Help & support</h3>
                <p>
                    We’re here to help with any questions or issues:
                    <br />
                    <NavLink to="mailto:admin@shayaantravel.co.uk">admin@shayaantravel.co.uk</NavLink>
                </p>
        </div>

        <div className="contact-info">
            <h3><i className="fa fa-map-marker"></i> Our location</h3>
                <p>
                525 abbeydale Road Sheffield S7 1FU
                    <br />
                    {/* <NavLink target="_blank" to="https://g.page/ams-web-design-company-in-delhi?share">Show on map</NavLink> */}
                </p>
        </div>
        
        <div className="contact-info">
            <h3><i className="fa fa-dollar"></i> Contact Info</h3>
                <p>
                07548315421
                    <br />
                    <NavLink to="mailto:admin@shayaantravel.co.uk">admin@shayaantravel.co.uk</NavLink>
                </p>
        </div>
        
    </div>
</div>

</div>

<Googlemap />
      
      </Layout>
    </>
  )
}
const Spinner = () => {
  return (
    <div className='spinner-border' role='status'>
      <span className='visually-hidden'>Loading...</span>
    </div>
  )
}
export default Contact
